import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Layout from './views/Layout'
import { cloneDeep } from 'lodash'
import axios from 'axios'
import db from './db'

Vue.use(Router)

const LOGIN_PATH = '/login'
const SET_PASSWORD_PATH = '/set-password'
const FORGET_PASSWORD_PATH = '/forget-password'
const ERROR_MSG = '/error'

export const constantRoutes = [
  { path: LOGIN_PATH, component: () => import('./views/Login') },
  { path: SET_PASSWORD_PATH, component: () => import('./views/SetPassword') },
  { path: FORGET_PASSWORD_PATH, component: () => import('./views/ForgetPassword') },
  { path: ERROR_MSG, component: () => import('./views/ErrorMsg') },
  { path: '*', component: () => import('./views/NotFound') }
]

/**
 * show: true 是否显示在侧边栏 默认 false
 * permissions: ['Management_Campaign_R'] 访问权限
 * icon: ''  iconfont 名字
 * label 菜单栏的标题
 * active 子路由匹配高亮的正则
 */
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      // dashboard(旧)
      {
        // show: true,
        label: '看板',
        icon: 'icon-kanban',
        active: /^\/shortcut-dashboard/,
        path: '/shortcut-dashboard',
        permissions: ['Dashboard_R'],
        component: () => import('./views/ShortcutDashboard')
      },

      // dashboard
      {
        show: true,
        label: '看板',
        icon: 'icon-kanban',
        active: /^\/dashboard/,
        path: '/dashboard',
        permissions: ['Dashboard_R'],
        component: () => import('./views/Dashboard')
      },

      // unistar 新建
      {
        path: '/unistar/new-unistar-campaign',
        component: () => import('./views/Unistar/NewUnistarCampaign')
      },

      // campaign list
      {
        path: '/campaign/list',
        show: true,
        label: '项目',
        icon: 'icon-huodong',
        active: /^(\/campaign|\/shortcut)\//,
        permissions: ['Management_Campaign_R'],
        component: () => import('./views/CampaignListContainer'),
        children: [
          {
            path: '/campaign/list',
            show: true,
            active: /^(\/campaign|\/shortcut)\//,
            label: '营销采购项目',
            permissions: ['Master_Campaign_R'],
            component: () => import('./views/CampaignList')
          },
          {
            path: '/ec-campaign/list',
            show: true,
            active: /^(\/ec-campaign)\//,
            label: '媒体投放项目',
            permissions: ['EC_Campaign_R'],
            component: () => import('./views/ECCampaign/ECCampaignList')
          },
          {
            path: '/unistar/list',
            show: true,
            active: /^(\/unistar)\//,
            label: '明星合作项目',
            permissions: ['Management_Campaign_R'],
            component: () => import('./views/Unistar/UnistarList')
          }
        ]
      },

      // EC campaign
      {
        path: '/ec-campaign/overview',
        component: () => import('./views/ECCampaign/CampaignOverview')
      },
      {
        path: '/ec-campaign/new-campaign',
        component: () => import('./views/ECCampaign/NewCampaign')
      },
      {
        path: '/ec-campaign/process',
        component: () => import('./views/ECCampaign/ECCampaignProcess'),
        redirect: 'ec-campaign/process/basic-info-v1',
        children: [
          {
            path: 'basic-info-v1',
            component: () => import('./views/ECCampaign/BasicInfo')
          },
          {
            path: 'buying-brief-v1',
            component: () => import('./views/ECCampaign/BuyingBrief')
          },
          {
            path: 'io-info-v1',
            component: () => import('./views/ECCampaign/IOInfo')
          },
          {
            path: 'material-info-v1',
            component: () => import('./views/ECCampaign/MaterialInfo')
          },
          {
            path: 'campaign-participant-v1',
            component: () => import('./views/ECCampaign/CampaignParticipant')
          },
          {
            path: 'tp-audit-v1',
            component: () => import('./views/ECCampaign/TPAudit')
          },
          {
            path: 'ec-audit-v1',
            component: () => import('./views/ECCampaign/ECAudit')
          },
          {
            path: 'marketing-lv2-audit-v1',
            component: () => import('./views/ECCampaign/MarketingLv2Audit')
          },
          {
            path: 'marketing-lv3-audit-v1',
            component: () => import('./views/ECCampaign/MarketingLv2Audit')
          }

        ]
      },

      // 新建 campaign
      {
        path: '/campaign/new-campaign-and-brief',
        alias: ['/campaign/new-campaign-and-brief-v2', '/campaign/new-campaign-and-brief-v3'], // 新建 合并流程campaign
        component: () => import('./views/NewCampaignAndBrief')
      },
      // 新建或编辑 shortcut campaign
      {
        path: '/campaign/new-shortcut',
        component: () => import('./views/NewShortcutCampaign')
      },
      {
        path: '/campaign/edit-shortcut',
        component: () => import('./views/EditShortcutCampaign')
      },
      {
        path: '/unistar',
        redirect: '/unistar/list',
        component: () => import('./views/Unistar'),
        children: [
          {
            path: 'campaign-overview', // unistar 概览
            component: () => import('./views/Unistar/UnistarCampaignoverview')
          },
          {
            path: 'flow', // unistar flow
            redirect: '/unistar/flow/campaign-info',
            component: () => import('./views/Unistar/flow'),
            children: [
              // 明星项目
              {
                path: 'campaign-info', // 明星项目信息
                component: () => import('./views/Unistar/flow/CampaignInfo')
              },
              {
                path: 'procurement-enquiry-and-approve', // 采购部询价与审批
                component: () => import('./views/Unistar/flow/ProcurementEnquiryAndApprove')
              },
              {
                path: 'marketing-select-star', // 市场部选择明星
                component: () => import('./views/Unistar/flow/MarketingSelectStar')
              },
              {
                path: 'finance-audit-Quotation', // 财务审批报价
                component: () => import('./views/Unistar/flow/FinanceAuditQuotation')
              },
              {
                path: 'procurement-negotiation', // 采购部谈判
                component: () => import('./views/Unistar/flow/ProcurementNegotiation')
              },
              {
                path: 'marketing-upload-contract-and-do', // 市场部上传和同&DO
                component: () => import('./views/Unistar/flow/MarketingUploadContractAndDo')
              },
              // 执行子项目
              {
                path: 'sow-info', // 执行子项目信息
                component: () => import('./views/Unistar/flow/SOWInfo')
              },
              {
                path: 'vendor-upload-quotation', // 供应商报价
                component: () => import('./views/Unistar/flow/VendorUploadQuotation')
              },
              {
                path: 'procurement-confirm-quotation', // 采购部确认报价
                component: () => import('./views/Unistar/flow/ProcurementConfirmQuotation')
              },
              {
                path: 'marketing-upload-sow-contract-and-do', // 执行子项目传合同&DO
                component: () => import('./views/Unistar/flow/MarketingUploadSOWContractAndDo')
              }
            ]
          }
        ]
      },
      // 快捷版
      {
        path: '/shortcut',
        component: () => import('./views/Shortcut'),
        children: [
          {
            path: 'category',
            component: () => import('./views/Shortcut/children/ShortcutCategory')
          },
          {
            path: 'quotation',
            component: () => import('./views/Shortcut/children/ShortcutQuotation')
          },
          {
            path: 'report',
            component: () => import('./views/Shortcut/children/ShortcutReport')
          },
          {
            path: 'evaluation',
            component: () => import('./views/Shortcut/children/ShortcutEvaluation')
          },
          {
            path: 'participants',
            component: () => import('./views/Flow/children/CampaignParticipants')
          },
          {
            path: 'dot',
            component: () => import('./views/Flow/children/DOT'),
            redirect: '/social-tracking',
            children: [
              {
                path: 'social-tracking',
                component: () => import('./views/Flow/children/DOT/SocialTracking')
              }
            ]
          }
        ]
      },
      // 账户列表
      {
        path: '/user/list',
        // show: true,
        label: '账户',
        icon: 'icon-icon-order',
        permissions: ['Management_Campaign_R'],
        active: /^\/user/,
        component: () => import('./views/UserList')
      },

      // 账户信息
      {
        path: '/user/info',
        component: () => import('./views/UserInfo')
      },

      // 流程相关
      {
        path: '/flow',
        alias: ['campaign', 'vendor-campaign'],
        component: () => import('./views/Flow'),
        children: [
          {
            path: 'process',
            component: () => import('./views/Flow/children/CampaignProcess')
          },
          {
            path: 'participants',
            component: () => import('./views/Flow/children/CampaignParticipants')
          },
          {
            path: 'dot',
            component: () => import('./views/Flow/children/DOT'),
            redirect: 'dot/social-tracking',
            children: [
              {
                path: 'social-tracking',
                alias: ['social-tracking-v3'],
                component: () => import('./views/Flow/children/DOT/SocialTracking')
              }
            ]
          },
          // phase1
          // 市场部上级审核新项目
          {
            path: 'new-marketing-leader-audit',
            alias: ['new-marketing-leader-audit-v2'],
            component: () => import('./views/Flow/children/MarketingLeaderAudit')
          },
          {
            path: 'new-marketing-leader-audit-v3',
            component: () => import('./views/Flow/children/NewMarketingLeaderAudit')
          },
          {
            path: 'marketing-lv4-audit',
            alias: ['marketing-lv4-audit-v3'],
            component: () => import('./views/Flow/children/MarketingLv4Audit')
          },
          // 市场部上传 Brief & 推荐供应商
          {
            path: 'marketing-upload-brief',
            alias: ['marketing-upload-brief-v2', 'marketing-upload-brief-v3'],
            component: () => import('./views/Flow/children/MarketingUploadBrief')
          },
          // it-推荐供应商
          {
            path: 'it-recommend-vendor',
            alias: ['it-recommend-vendor-v2', 'it-recommend-vendor-v3'],
            component: () => import('./views/Flow/children/ITRecommendVendor'),
            props: { isFinalScope: 0 }
          },
          // 采购部 选择供应商
          {
            path: 'procurement-select-vendor',
            alias: ['procurement-select-vendor-v2'],
            component: () => import('./views/Flow/children/ProcurementSelectVendor')
          },
          {
            path: 'procurement-select-vendor-v3',
            component: () => import('./views/Flow/children/ProcurementSelectVendorV3')
          },
          // 查看供应商方案 上传进度
          {
            path: 'vendor-upload-progress',
            alias: ['vendor-upload-progress-v2'],
            component: () => import('./views/Flow/children/VendorUploadProgress')
          },
          // 上传方案v3
          {
            path: 'vendor-upload-progress-v3',
            component: () => import('./views/Flow/children/VendorUploadProgressV3')
          },
          // 市场部确定供应商
          {
            path: 'marketing-confirm-vendor',
            alias: ['marketing-confirm-vendor-v2', 'marketing-confirm-vendor-v3'],
            component: () => import('./views/Flow/children/MarketingConfirmVendor')
          },
          // phase 2
          // 采购部拆分final scope & 选择供应商
          {
            path: 'procurement-split-fs-and-choose-vendor',
            alias: ['procurement-split-fs-and-choose-vendor-v2'],
            component: () => import('./views/Flow/children/ProcurementSplitFSAndChooseVendor')
          },
          {
            path: 'procurement-split-fs-and-choose-vendor-v3',
            component: () => import('./views/Flow/children/ProcurementSplitFSAndChooseVendorV3')
          },
          // 采购部下发SOW
          {
            path: 'procurement-deliver-sow',
            alias: ['procurement-deliver-sow-v2', 'procurement-deliver-sow-v3'],
            component: () => import('./views/Flow/children/ProcurementDeliverSow')
          },
          // 采购部查看并审核sub final scope 报价
          {
            path: 'procurement-audit-sfs-quotation',
            alias: ['procurement-audit-sfs-quotation-v2'],
            component: () => import('./views/Flow/children/ProcurementAuditSFSQuotation')
          },
          // 采购部查看并审核sub final scope 报价v3
          {
            path: 'procurement-audit-sfs-quotation-v3',
            component: () => import('./views/Flow/children/ProcurementAuditSFSQuotationV3')
          },
          // 采购部 选择报价 确定供应商
          {
            path: 'procurement-choose-quotation-and-confirm-vendor',
            alias: ['procurement-choose-quotation-and-confirm-vendor-v2', 'procurement-choose-quotation-and-confirm-vendor-v3'],
            component: () => import('./views/Flow/children/ProcurementChooseQuotationAndConfirmVendor')
          },
          {
            // 市场部 上传Final Scope
            path: 'upload-final-scope',
            alias: ['upload-final-scope-v2'],
            component: () => import('./views/Flow/children/UploadFinalScope')
          },
          {
            // 市场部 上传Final Scope V3
            path: 'upload-final-scope-v3',
            component: () => import('./views/Flow/children/UploadFinalScopeV3')
          },
          {
            // 采购部 审核Final Scope
            path: 'procurement-audit-final-scope',
            alias: ['procurement-audit-final-scope-v2'],
            component: () => import('./views/Flow/children/ProcurementAuditFinalScope')
          },
          {
            // 采购部 审核Final Scope v3
            path: 'procurement-audit-final-scope-v3',
            component: () => import('./views/Flow/children/ProcurementAuditFinalScopeV3')
          },
          {
            // 采购部 确认项目类别
            path: 'verify-campaign-category',
            alias: ['verify-campaign-category-v2', 'verify-campaign-category-v3'],
            component: () => import('./views/Flow/children/VerifyCampaignCategory')
          },
          // it-推荐供应商
          {
            path: 'phase2-it-recommend-vendor',
            alias: ['phase2-it-recommend-vendor-v2', 'phase2-it-recommend-vendor-v3'],
            component: () => import('./views/Flow/children/ITRecommendVendor'),
            props: { isFinalScope: 1 }
          },
          {
            path: 'it-recommend-vendor-second-time',
            alias: ['it-recommend-vendor-second-time-v2', 'it-recommend-vendor-second-time-v3'],
            component: () => import('./views/Flow/children/ITRecommendVendor'),
            props: { isFinalScope: 1 }
          },
          {
            // IT 审核报价
            path: 'it-audit-quotation',
            alias: ['it-audit-quotation-v2'],
            component: () => import('./views/Flow/children/ItAuditQuotation')
          },
          {
            // IT 审核报价 v3
            path: 'it-audit-quotation-v3',
            component: () => import('./views/Flow/children/ItAuditQuotationV3')
          },
          {
            // 市场部 填写IO号
            path: 'fill-io-in',
            alias: ['fill-io-in-v2', 'fill-io-in-v3'],
            component: () => import('./views/Flow/children/FillIoIn')
          },

          {
            // 市场部 复核报价
            path: 'audit-quotation',
            alias: ['audit-quotation-v2'],
            component: () => import('./views/Flow/children/AuditQuotation')
          },
          {
            // 市场部 复核报价 v3
            path: 'audit-quotation-v3',
            component: () => import('./views/Flow/children/AuditQuotationV3')
          },
          {
            // 市场部lv3 审核报价
            path: 'marketing-lv3-audit-quotation',
            alias: ['marketing-lv3-audit-quotation-v2', 'marketing-lv3-audit-quotation-v3'],
            component: () => import('./views/Flow/children/MarketingLv3AuditQuotation')
          },
          // phase 3
          // 上传合同号/DO号
          {
            path: 'upload-contract-do',
            alias: ['upload-contract-do-v2', 'upload-contract-do-v3'],
            component: () => import('./views/Flow/children/UploadContractAndDo')
          },
          // phase 4
          // 市场部--审核结案报告
          {
            path: 'market-closing-info-audit',
            alias: ['market-closing-info-audit-v2', 'market-closing-info-audit-v3'],
            component: () => import('./views/Flow/children/MarketClosingInfoAudit')
          },
          // Lv3--审核结案报告
          {
            path: 'lv3-closing-info-audit',
            alias: ['lv3-closing-info-audit-v2', 'lv3-closing-info-audit-v3'],
            component: () => import('./views/Flow/children/Lv3ClosingInfoAudit')
          },
          // IT--审核结案报告
          {
            path: 'it-closing-info-audit',
            alias: ['it-closing-info-audit-v2', 'it-closing-info-audit-v3'],
            component: () => import('./views/Flow/children/ITClosingInfoAudit')
          },
          // 采购部--审核发送确认邮件
          {
            path: 'procurement-audit-and-send-email',
            alias: ['procurement-audit-and-send-email-v2', 'procurement-audit-and-send-email-v3'],
            component: () => import('./views/Flow/children/ProcurementAuditAndSendEmail')
          },
          // 上传合同 & 增量DO
          {
            path: 'upload-contract-and-increament-do',
            alias: ['upload-contract-and-increament-do-v2', 'upload-contract-and-increament-do-v3'],
            component: () => import('./views/Flow/children/UploadContractAndDo'),
            props: { increment: 1 }
          },
          // 下发签收单
          {
            path: 'issue-receipt',
            alias: ['issue-receipt-v2', 'issue-receipt-v3'],
            component: () => import('./views/Flow/children/IssueReceipt')
          },
          // 评价供应商
          {
            path: 'evaluate-vendor',
            alias: ['evaluate-vendor-v2', 'evaluate-vendor-v3'],
            component: () => import('./views/Flow/children/EvaluateVendor')
          },
          {
            path: 'view-final-report',
            alias: ['view-final-report-v2', 'view-final-report-v3'],
            component: () => import('./views/Flow/children/ViewFinalReport')
          },
          // 供应商相关流程
          // 查看brief
          {
            path: 'view-brief',
            alias: ['view-brief-v2', 'view-brief-v3'],
            component: () => import('./views/Flow/children/ViewBrief')
          },
          // 查看订单
          {
            path: 'vendor-view-order',
            alias: ['vendor-view-order-v2', 'vendor-view-order-v3'],
            component: () => import('./views/Flow/children/VendorViewOrder')
          },
          // 上传方案
          {
            path: 'vendor-upload-proposal',
            alias: ['vendor-upload-proposal-v2', 'vendor-upload-proposal-v3'],
            component: () => import('./views/Flow/children/VendorUploadProposal')
          },
          // 填写报价
          {
            path: 'fill-quotation',
            alias: ['fill-quotation-v2', 'fill-quotation-v3'],
            component: () => import('./views/Flow/children/FillQuotation')
          },
          // 查看服务内容
          {
            path: 'view-subfinalscope',
            alias: ['view-subfinalscope-v2', 'view-subfinalscope-v3'],
            component: () => import('./views/Flow/children/ViewSubFinalScope')
          },
          // 查看中标结果
          {
            path: 'vendor-view-bid-result',
            alias: ['vendor-view-bid-result-v2', 'vendor-view-bid-result-v3'],
            component: () => import('./views/Flow/children/VendorViewBidResult')
          },
          // 上传Spotplan
          {
            path: 'vendor-upload-spotplan',
            alias: ['vendor-upload-spotplan-v2', 'vendor-upload-spotplan-v3'],
            component: () => import('./views/Flow/children/VendorUploadSpotplan')
          },
          // 查看spotplan审核结果
          {
            path: 'vender-view-spotplan-result',
            alias: ['vender-view-spotplan-result-v2', 'vender-view-spotplan-result-v3'],
            component: () => import('./views/Flow/children/VenderViewSpotplanResult')
          },
          // 查看审核结果
          {
            path: 'vendor-view-audit-result',
            alias: ['vendor-view-audit-result-v2', 'vendor-view-audit-result-v3'],
            component: () => import('./views/Flow/children/VenderViewAuditResult')
          },
          // 上传结案报告
          {
            path: 'final-report-upload',
            alias: ['final-report-upload-v2', 'final-report-upload-v3'],
            component: () => import('./views/Flow/children/FinalReportUpload')
          },
          // 查看签收单
          {
            path: 'signature',
            alias: ['signature-v2', 'signature-v3'],
            component: () => import('./views/Flow/children/Signature')
          }
        ]
      },
      // vendor 的项目列表
      {
        path: '/vendor-campaign/list',
        show: true,
        label: '项目列表',
        icon: 'icon-icon-order',
        active: /^(\/vendor-campaign|\/shortcut)\//,
        permissions: ['Management_Order_R'],
        component: () => import('./views/VendorCampaignList')
      },

      // vendor list
      {
        path: '/vendor/list',
        show: true,
        label: '供应商',
        icon: 'icon-icon-order',
        active: /^\/vendor/,
        permissions: ['Vendor_List_R'],
        component: () => import('./views/VendorListNew')
      },

      // vendor info
      {
        path: '/vendor/info',
        component: () => import('./views/VendorInfo'),
        children: [
          {
            path: 'basic-info',
            component: () => import('./views/VendorInfo/children/BasicInfoNew')
          },
          {
            path: 'public-info',
            component: () => import('./views/VendorInfo/children/PublicInfoNew')
          },
          {
            path: 'history-info',
            component: () => import('./views/VendorInfo/children/HistoryInfo')
          }
        ]
      },

      {
        path: '/vendor-management/invited-list',
        component: () => import('./views/VendorInvitedList')
      },

      {
        // 联合利华 新建供应商
        path: '/vendor-management/new-vendor',
        component: () => import('./views/NewVendor')
      },

      // information
      {
        path: '/information/edit',
        redirect: '/information/edit/general',
        component: () => import('./views/Information/Edit'),
        children: [
          {
            // 供应商 填写general
            path: 'general',
            component: () => import('./views/Information/Edit/General')
          },
          {
            // 供应商 填写capability
            path: 'capability',
            component: () => import('./views/Information/Edit/Capability')
          }
        ]
      },
      {
        path: '/information/view/basic-info',
        show: true,
        label: '信息',
        icon: 'icon-icon-order',
        active: /^\/information/,
        permissions: ['Vendor_Detail_R'],
        component: () => import('./views/Information/View/BasicInfo')
      },
      {
        path: '/information/view/category-info',
        component: () => import('./views/VendorInfo/children/BasicInfo/children/CategoryInfo')
      },

      // vendor account management
      {
        path: '/vendor-account/list',
        show: false,
        label: '账号管理',
        active: /^\/vendor-account/,
        icon: 'icon-huodong',
        component: () => import('./views/VendorAccountList')
      },
      {
        path: '/vendor-account/new',
        component: () => import('./views/NewVendorAccount')
      },
      {
        path: '/kol-list',
        show: true,
        label: 'KOL',
        icon: 'icon-kol1',
        active: /^\/kol/,
        permissions: ['Kol_Evaluation_V'],
        component: () => import('./views/KolList')
      },
      {
        path: '/kol-info',
        component: () => import('./views/KolInfo')
      },
      {
        path: '/custom-template/list',
        show: true,
        label: '自定义报告',
        icon: 'icon-report1',
        active: /^\/custom-template/,
        permissions: ['Custom_Report_R'],
        component: () => import('./views/CustomTemplate/CustomTemplateList')
      },
      {
        path: '/custom-template/new-custom-template',
        component: () => import('./views/CustomTemplate/CustomTemplateNew')
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes: constantRoutes
})

let shouldGenerateRoutes = true
router.beforeEach(async (to, from, next) => {
  const element = document.querySelector('.campaign__flow-container')
  if (element) {
    element.scrollTop = 0
  }
  let user = store.getters.user
  await setKolStoreState(to, from)
  await setVendorStoreState(to, from)
  await setStoreState(to, next)
  if (user) {
    if (to.path === LOGIN_PATH) {
      next('/')
    } else {
      if (to.path === '/unistar/new-unistar-campaign') {
        axios.post('/signin')
          .then((res) => {
            store.commit('common/setUser', res.user)
          })
      }
      if (shouldGenerateRoutes) {
        store.commit('common/setRoutes', generateCanAccessRoutes(cloneDeep(asyncRoutes), user.permissions))
        router.addRoutes(store.getters.routes)
        shouldGenerateRoutes = false
        if (to.path === '/') {
          next(store.getters.user.redirect_url)
        } else {
          next({ ...to, replace: true })
        }
      } else {
        if (to.path === '/campaign/list' && !user.permissions.includes('Master_Campaign_R')) {
          next('/ec-campaign/list')
        } else {
          next()
        }
      }
    }
  } else {
    shouldGenerateRoutes = true
    if (to.path === LOGIN_PATH || to.path === SET_PASSWORD_PATH || to.path === FORGET_PASSWORD_PATH || to.path === ERROR_MSG) {
      next()
    } else {
      if (to.query.redirect_from && to.query.redirect_from === 'email') {
        db.from_url = window.location.href
        next(LOGIN_PATH + `?redirect_url=${to.path}`)
      } else {
        axios.post('/signin')
          .then(res => {
            if (res.user) {
              store.commit('common/setUser', res.user)
              console.log('to', to)
              next({ ...to, replace: true })
            } else {
              db.from_url = window.location.href
              next(LOGIN_PATH + `?redirect_url=${to.path}`)
            }
          })
          .catch(err => {
            next('/login')
            throw new Error(err)
          })
      }
    }
  }
})

router.afterEach((to, from) => {
  const element = document.querySelectorAll('.el-message--error')
  Array.prototype.forEach.call(element, node => {
    node.parentNode.removeChild(node)
  })
})

function generateCanAccessRoutes (routes, permissions) {
  function hasPermission (route, permissions) {
    if (route.permissions) {
      return permissions.some(p => route.permissions.includes(p))
    } else {
      return true
    }
  }

  function filterRoutes (routes) {
    return routes.filter(r => {
      if (hasPermission(r, permissions)) {
        if (r.children && r.children.length) r.children = filterRoutes(r.children, permissions)
        return true
      }
      return false
    })
  }
  return filterRoutes(routes)
}

async function setKolStoreState (to, from) {
  if (to.path === '/kol-list' && from.path !== '/kol-info') {
    const defaultColumn = [
      'history_price',
      'price_newrank',
      'price_ims',
      'fans',
      'avg_likes'
    ]
    store.commit('kol/setWechatSelectedColumn', defaultColumn)
    store.commit('kol/setWechatCheckedColumn', defaultColumn)
    store.commit('kol/setWeiboSelectedColumn', defaultColumn)
    store.commit('kol/setWeiboCheckedColumn', defaultColumn)
    store.commit('kol/setKolChannel', 'wechat')
  }
}

async function setVendorStoreState (to, from) {
  if (to.path === '/vendor/list' && from.path !== '/vendor-management/new-vendor' && from.path !== '/vendor-management/new-vendor') {
    store.commit('vendor/setVendorTabIndex', 0)
  }
}

async function setStoreState (to, next) {
  const query = to.query
  if (!query.redirect_from || query.redirect_from !== 'email') return
  let res = {
    status: true
  }
  if (query.task_id) {
    res = await axios.get('/common/getTaskStatus', {
      params: {
        task_id: query.task_id
      }
    })
  }
  // 如果可以操作
  if (res.status) {
    if (to.path.includes('/unistar/')) {
      store.commit('unistar/setCampaignInfo', {
        campaign_id: Number(query.campaign_id),
        campaign_name: query.campaign_name
      })
      const sowInfo = {
        sub_final_scope_id: Number(query.sub_final_scope_id),
        campaign_id: Number(query.campaign_id),
        business_type: Number(query.business_type),
        business_key: Number(query.business_key),
        phase_type: Number(query.phase_type)
      }
      if (query.phase === 'StarOrder') {
        sowInfo.type = '明星合作项目'
      }
      store.commit('unistar/setSOWInfo', sowInfo)
    } else {
      store.commit('campaign/setDotSubFinalScopeId', query.sub_final_scope_id ? query.sub_final_scope_id : null)
      store.commit('campaign/setId', query.campaign_id ? Number(query.campaign_id) : null)
      store.commit('campaign/setTaskId', query.task_id ? query.task_id : null)
      store.commit('campaign/setTaskName', query.task_name)
      store.commit('campaign/setBusinessType', query.business_type ? Number(query.business_type) : null)
      store.commit('campaign/setOriginalBusinessType', query.business_type ? Number(query.business_type) : null)
      store.commit('campaign/setIsNewBrief', query.is_new_brief ? Number(query.is_new_brief) : null)
      store.commit('campaign/setSubFinalScopeId', query.sub_final_scope_id ? Number(query.sub_final_scope_id) : null)
      store.commit('campaign/setSubFinalScopeVendorId', query.sub_final_scope_vendor_id ? Number(query.sub_final_scope_vendor_id) : null)
      store.commit('campaign/setDeliverVendorId', query.deliver_vendor_id ? Number(query.deliver_vendor_id) : null)
      store.commit('campaign/setBusinessKey', query.business_key ? Number(query.business_key) : null)
      store.commit('campaign/setCampaignName', query.campaign_name)
      store.commit('campaign/setPhaseType', query.phase_type ? Number(query.phase_type) : null)
    }
    return Promise.resolve()
  } else {
    next(store.getters.user.redirect_url)
  }
}
export default router
